import { AccessTime, CheckCircle } from "@mui/icons-material";
import { Chip, type ChipProps } from "@mui/material";
import React from "react";
import type { Order } from "../../types/api";

interface StatusChipProps extends Omit<ChipProps, "color" | "icon" | "label"> {
  status: Order["status"];
  size?: "small" | "medium";
}

const StatusChip: React.FC<StatusChipProps> = ({ status, size = "medium", sx, ...props }) => {
  const getStatusColor = (
    status: Order["status"]
  ): "success" | "warning" | "info" | "error" | "default" => {
    switch (status) {
      case "fulfilled":
      case "paid":
        return "success";
      case "processing":
        return "warning";
      case "pending":
        return "info";
      case "refunded":
        return "error";
      default:
        return "default";
    }
  };

  const getStatusIcon = (status: Order["status"]) => {
    switch (status) {
      case "fulfilled":
      case "paid":
        return <CheckCircle />;
      case "processing":
      case "pending":
        return <AccessTime />;
      default:
        return <AccessTime />;
    }
  };

  return (
    <Chip
      icon={getStatusIcon(status)}
      label={status.toUpperCase()}
      color={getStatusColor(status)}
      size={size}
      sx={{ fontWeight: 600, ...sx }}
      {...props}
    />
  );
};

export default StatusChip;
